<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandleSlaveWithSuite from "../DesignerQuestionHardwareHandleSlaveWithSuite.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandleSlaveWithSuite,
        ],
        props: {
            title: {
                default() {
                    return 'Select Your Door Handle';
                }
            }
        }
    }
</script>
